import { render, staticRenderFns } from "./Depth5Point.vue?vue&type=template&id=6a603344&scoped=true&"
import script from "./Depth5Point.vue?vue&type=script&lang=js&"
export * from "./Depth5Point.vue?vue&type=script&lang=js&"
import style0 from "./Depth5Point.vue?vue&type=style&index=0&id=6a603344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a603344",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a603344')) {
      api.createRecord('6a603344', component.options)
    } else {
      api.reload('6a603344', component.options)
    }
    module.hot.accept("./Depth5Point.vue?vue&type=template&id=6a603344&scoped=true&", function () {
      api.rerender('6a603344', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/vendors/Terms/Depth5Point.vue"
export default component.exports